import { ref } from 'vue';

const DEFAULT_SHOW_SYMBOLS = true;

// Factory for creating instance-scoped show-symbols state
export function createShowSymbols(options?: { showSymbols?: boolean }) {
  const showSymbols = ref(options?.showSymbols ?? DEFAULT_SHOW_SYMBOLS);
  return { showSymbols };
}

export {
  DEFAULT_SHOW_SYMBOLS
}
